import React from "react";
import { Row, Col } from "react-bootstrap";

import Heading_title from "../../common-components/common-title/heading-title/Heading_title";
import "./Our_Philosophy.css";
import Common_Title_2 from "../../common-components/common_title_2/Common_Title_2";

const philosophyData = [
  {
    id: 1,
    title: "Taste Comes First",
    image: "/assets/images/home/our-philosophy/img1.png",
    description:
      "If it doesn’t excite your taste buds, it doesn’t leave our factory.",
  },
  {
    id: 2,
    title: "Mass Before Class",
    image: "/assets/images/home/our-philosophy/img2.png",
    description:
      "Great taste and quality should be affordable for every household, every day.",
  },
  {
    id: 3,
    title: "Distribution is King",
    image: "/assets/images/home/our-philosophy/img3.png",
    description:
      "A product only matters when it’s available where India actually shops — kirana stores, local markets, modern trade, and online.",
  },
  {
    id: 4,
    title: "Build for Scale",
    image: "/assets/images/home/our-philosophy/img4.png",
    description:
      "From small towns to large cities, we build products and distribution designed to grow across Bharat.",
  },
];

const Our_Philosophy = () => {
  return (
    <section className="our_philosophy">
      <div className="container">
        {/* <Heading_title title={"Our Philosophy"} /> */}

        <Common_Title_2 titleText="Our Philosophy" />

        <Row className="g-4 philosophy_cards">
          {philosophyData.map((item) => (
            <Col xxl={3} xl={3} lg={3} md={6} sm={6} xs={6} key={item.id}>
              <div className="philosophy_card">
                <h3 className="title">{item.title}</h3>

                <div className="philosophy_img_wrapper">
                  <img src={item.image} alt={item.title} className="image" />
                </div>

                <p className="description">{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default Our_Philosophy;
